<template>
	<div class="user-container">
		<el-button type="success" style="margin-bottom: 20px;" @click="openDialog('1')">新增</el-button>
		<el-table :data="tableData" style="width: 100%" stripe border>
			<el-table-column prop="id" label="id">
			</el-table-column>
			<el-table-column prop="name" label="分类名">
			</el-table-column>
			<el-table-column width="175">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="openDialog('2',scope.row)">修改</el-button>
					<delPop @confirm="delUser(scope.row.id)"></delPop>
				</template>
			</el-table-column>
		</el-table>
		<div style="display: flex;justify-content: center;">
			<el-pagination background layout="prev, pager, next" :total="total" style="margin-top: 40px;" @current-change="changePage">
			</el-pagination>
		</div>
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="35%">
			<div>
				<el-form label-width="80px" :model="model" ref="userForm" :rules="rules">
					<el-form-item label="分类名" prop="name">
						<el-input :disabled="dialogTitle == '修改'" v-model="model.name"></el-input>
					</el-form-item>
					<el-form-item label="新分类名" prop="newName" v-if="dialogTitle == '修改'">
						<el-input v-model="model.newName"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="commit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import mixins from '../../mixins.js'
	import {
		classifys,
		addClassify,
		delClassify,
		updateClassify
	} from '../../api/classify.js'
	export default {
		mixins: [mixins],
		data() {
			return {
				tableData: [],
				dialogTitle: '新增',
				dialogVisible: false,
				model: {},
				rules: {
					name: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			async getData() {
				let res = (await classifys(this.queryParams)).data
				this.tableData = res.data
				this.total = res.count
			},
			openDialog(i, row) {
				if (i == 1) {
					this.dialogTitle = '新增'
					this.model = {}
				} else {
					this.dialogTitle = '修改'
					this.model = row
				}
				this.dialogVisible = true
			},
			async commit() {
				this.$refs.userForm.validate(async valid => {
					if (valid) {
						if (this.dialogTitle == '新增') {
							await addClassify(this.model)
						}else{
							await updateClassify(this.model)
						}
						this.getData()
						this.$message.success(this.dialogTitle + '成功')
						this.dialogVisible = false
					} else {
						return false
					}
				})
			},
			async delUser(id){
				await delClassify(id)
				this.$message.success('删除成功')
				this.getData()
			}
		}
	}
</script>

<style>
</style>
